




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Job } from '@/types'

@Component
export default class Jobs extends Vue {
  @Prop() jobs!: Array<Job>;
}
